import { ListaPerguntas, PerguntaResponse } from 'api/Associado/duvidas';

import { Messenger } from 'store/modules/WSAssembleiasReducer';

export enum Sections {
  'list',
  'ask',
  'answer',
}

export interface Perguntas {
  publicas: ListaPerguntas;
  usuario: ListaPerguntas;
}

interface DuvidasState {
  idEvento: number;
  section: Sections;
  perguntas: Perguntas | null;
  tab: 0 | 1;
  isLoading: boolean;
  perguntaAtual: PerguntaResponse | null;
  message: Messenger | null;
}

type DuvidasActionTypes =
  | 'setSection'
  | 'setPerguntas'
  | 'setTab'
  | 'loading'
  | 'loaded'
  | 'setPergunta'
  | 'setMessage'
  | 'setEvento';

interface DuvidasAction {
  type: DuvidasActionTypes;
  value?: any;
}

export const duvidasInitialState: DuvidasState = {
  isLoading: false,
  perguntas: null,
  section: Sections['list'],
  tab: 0,
  perguntaAtual: null,
  message: null,
  idEvento: 0,
};

export const duvidasReducer = (state: DuvidasState, action: DuvidasAction): DuvidasState => {
  switch (action.type) {
    case 'loading':
      return { ...state, isLoading: true };
    case 'loaded':
      return { ...state, isLoading: false };
    case 'setPerguntas':
      return { ...state, perguntas: action.value };
    case 'setSection':
      return { ...state, section: action.value };
    case 'setTab':
      return { ...state, tab: action.value };
    case 'setPergunta':
      return { ...state, perguntaAtual: action.value };
    case 'setMessage':
      return { ...state, message: action.value };
    case 'setEvento':
      return { ...state, idEvento: action.value };
    default:
      return state;
  }
};
